

import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory } from 'react-router';
import createExpirationTransform from 'redux-persist-transform-expire';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { persistStore, autoRehydrate } from 'redux-persist';
import asyncLocalStoragefrom from 'redux-persist/storages';
import thunk from 'redux-thunk';
import createLogger from 'redux-logger';
import './css/app.css';
import AppReducer from './reducers';


/** Screen components */
import * as UserActions from './actions/user_actions';
import * as FacilitiesActions from './actions/facilities_actions';
import * as PatientsActions from './actions/admin/patients_actions';

import Home from './screens/home';
import SideMenu from './components/sideMenu';
import Securityquestion from './components/securityquestion';
import NewPassword from './components/newPassword';

import Facilities from './components/facilitiesScreen/facilities';
import Addfacility from './components/facilitiesScreen/add-facility';
import Editfacility from './components/facilitiesScreen/edit-facility';
import FacilitiesDetails from './components/facilitiesScreen/facility-details';
import FacilitiesAdmin from './components/facilitiesScreen/add-facility-admin';
import EditFacilitiesAdmin from './components/facilitiesScreen/edit-facility-admin';

import Registration from './screens/registration';
import Dashboard from './components/dashboardScreen/dashboard';
import Questionnaire from './components/questionnaireScreen/questionnaire';
import SettingsScreen from './components/settingsScreen/settingsScreen';
import LogOut from './components/logOutscreen/logout';
import ForgotUname from './components/forgotUname';
import ForgotPassword from './components/forgotpassword';
import ResetPassword from './components/resetpassword';
import MoreNotifications from './components/dashboardScreen/moreNotifications';

import SuperAdminContainer from './components/superAdminContainer';
import AdminContainer from './components/adminContainer';

/* Admin Routes*/
import AddPatients from './components/admin/patients/add-patients';
import PatientsList from './components/admin/patients/patients-list';
import PatientsDetails from './components/admin/patients/patients-details';
import EditPatient from './components/admin/patients/edit-patient';
import AddOptionalQuestions from './components/admin/patients/add-optional-questions';

/* Admin-Staff Routes*/
import StaffList from './components/admin/staff/staffList';
import AddStaff from './components/admin/staff/addStaff';
import EditStaff from './components/admin/staff/editStaff';
import AdminDashboard from './components/admin/dashboard/dashboard';
import ClinicSetting from './components/admin/clinicSettings/clinicSetting';
import staffHome from './components/staff/staffHome';
import PatientsSummery from './components/admin/patients/patients-summery';
import PatientsSurveyResponse from './components/admin/patients/answerdSurvey';

import MultifacilitySelection from './components/multi-facility-selection';
import MultifacilityRequest from './components/multi-facility-request';

//tickets
import Tickets from './components/tickets/tickets'

let reduxLogger = createLogger();
var startTime = new Date().getTime();
var timeOutTime = startTime + (44 * 60 * 100000);
var previousInterVal;
let store = createStore(AppReducer,
    window.devToolsExtension ? window.devToolsExtension() : f => f,
    process.env.NODE_ENV === 'production'
        ? applyMiddleware(thunk)
        : applyMiddleware(thunk, reduxLogger),
    autoRehydrate()

);
//handleSession(timeOutTime);
let reduxInitTime = new Date();
const expireTransform = createExpirationTransform({
    expireKey: reduxInitTime.setHours(reduxInitTime.getHours() + 2)
});
window.addEventListener('load', () => {
    console.info('Page loaded at :' + new Date().getTime() + '-->' + 'Page will Reload at :' + timeOutTime);
    //handleSession(timeOutTime);
})

//when user close browser tab 
window.addEventListener('load', () => {
    if (window.performance) {
        // alert(performance.navigation.type);
        if (performance.navigation.type == 1) {
            caches.keys().then((names) => {
                names.forEach((name) => {
                    caches.delete(name);
                });
            });
        } else {
            localStorage.clear();
            sessionStorage.clear();
        }
    }
})

// if you don't want to use browser history
// createMemoryHistory from react-router
// let history = createMemoryHistory(location);
let persistor = persistStore(store,
    {
        storage: asyncLocalStoragefrom,
        //transforms: [expireTransform]
    },
    (err, prevSate) => {
        if (err) {
            console.log(err);
        }

        ReactDOM.render((
            <Provider store={store} persistor={persistor}>
                <Router history={browserHistory}>
                    <Route path='/' component={Home} onEnter={onRouteEnter} />
                    <Route path='/Home' component={Home} onEnter={onRouteEnter} />
                    <Route path='/register' component={Registration} onEnter={onRouteEnter} />
                    <Route path='/newpassword' component={NewPassword} onEnter={onRouteEnter} />
                    <Route path='/forgotuname' component={ForgotUname} onEnter={onRouteEnter} />
                    <Route path='/forgotpassword' component={ForgotPassword} onEnter={onRouteEnter} />
                    <Route path='/resetpassword' component={ResetPassword} onEnter={onRouteEnter} />
                    <Route path='/securityquestion' component={Securityquestion} onEnter={onRouteEnter} />
                    <Route path='/logOut' component={LogOut} onEnter={onRouteEnter} />
                    <Route path='/select-clinic' component={MultifacilitySelection} onEnter={onRouteEnter} />
                    <Route path='/acceptClinicRequest' component={MultifacilityRequest} onEnter={onRouteEnter} />

                    <Route authorize={[1, 2, 8]} component={SuperAdminContainer}>
                        <Route path='/sidemenu' component={SideMenu} onEnter={onRouteEnter} >
                            <Route path='/settingsScreen' component={SettingsScreen} onEnter={onRouteEnter} />
                        </Route>
                    </Route>
                    <Route authorize={[1, 2]} component={SuperAdminContainer}>
                        <Route path='/sidemenu' component={SideMenu} onEnter={onRouteEnter} >

                            <Route path='/dashboard' component={Dashboard} onEnter={onRouteEnter} />
                            <Route path='/tickets' component={Tickets} onEnter={onRouteEnter} />

                            <Route path='/facilities' component={Facilities} onEnter={onRouteEnter} />
                            <Route path='/add-facility' component={Addfacility} onEnter={onRouteEnter} />
                            <Route path='/edit-facilities' component={Editfacility} onEnter={onRouteEnter} />

                            <Route path='/facilities/details' component={FacilitiesDetails} onEnter={onRouteEnter} />
                            <Route path='/facilities/admin/add' component={FacilitiesAdmin} onEnter={onRouteEnter} />
                            <Route path='/facilities/admin/edit' component={EditFacilitiesAdmin} onEnter={onRouteEnter} />

                            <Route path='/questionnaire' component={Questionnaire} onEnter={onRouteEnter} />

                            <Route path='/moreNotification' component={MoreNotifications} onEnter={onRouteEnter} />


                        </Route>
                    </Route>

                    <Route authorize={[2]} component={AdminContainer}>
                        <Route path='/sidemenu' component={SideMenu} onEnter={onRouteEnter} >
                            <Route path='/admin/dashboard' component={AdminDashboard} onEnter={onRouteEnter} />

                            <Route path='/add-patients' component={AddPatients} onEnter={onRouteEnter} />
                            <Route path='/edit-patients-details' component={EditPatient} onEnter={onRouteEnter} />
                            <Route path='/add-optional-questions' component={AddOptionalQuestions} onEnter={onRouteEnter} />

                            <Route path='/admin/staff' component={StaffList} onEnter={onRouteEnter} />
                            <Route path='/admin/addStaff' component={AddStaff} onEnter={onRouteEnter} />
                            <Route path='/admin/editStaff' component={EditStaff} onEnter={onRouteEnter} />
                            <Route path='/admin/clinicsettings' component={ClinicSetting} onEnter={onRouteEnter} />
                            <Route path='/staff/staffHome' component={staffHome} onEnter={onRouteEnter} />
                        </Route>
                    </Route>

                    <Route authorize={[2, 8]} component={AdminContainer}>
                        <Route path='/sidemenu' component={SideMenu} onEnter={onRouteEnter} >
                            <Route path='/patients' component={PatientsList} onEnter={onRouteEnter} />
                            <Route path='/patients-details' component={PatientsDetails} onEnter={onRouteEnter} />
                            <Route path='/survey-analasys' component={PatientsSummery} onEnter={onRouteEnter} />
                            <Route path='/answerd-survey' component={PatientsSurveyResponse} onEnter={onRouteEnter} />

                        </Route>
                    </Route>
                </Router>
            </Provider >
        ), document.getElementById('root'));
    });

window.onerror = (message, source, lineno, colno, error) => {
    console.log(message, source, lineno, colno, error);
};

/*global ga*/

function onRouteEnter({ routes, params, location }, replaceFunc) {
    // function to be called when route is entered or the page is rendererd
    console.info('On Route Enter Called.....');
}


function handleSession(endTime) {
    console.log('index.js - handleSession called.')
    if (previousInterVal) {
        clearInterval(previousInterVal);
    }
    previousInterVal = setInterval(function () {
        var currentTime = new Date().getTime();
        if (currentTime >= endTime) {
            // localStorage.clear();
            // window.location.replace('/?timeout=1');
            console.log('index.js - UserActions.logout({});' + 'currentTime :' + currentTime + ',endTime :' + endTime);
            UserActions.logout({});
        }
    }, 1000);
}



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/